// export const hostAddress = "http://localhost:8080" 
export const hostAddress = "https://management.glowinme.app"
